import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium",
  {
    variants: {
      variant: {
        default: "bg-brand-50 text-brand-700 dark:bg-brand-900/40 dark:text-brand-300",
        brand: "bg-brand-600 text-white",
        good: "bg-good/10 text-good",
        warn: "bg-warn/10 text-warn",
        bad: "bg-bad/10 text-bad",
        muted: "bg-ink-100 dark:bg-ink-800 text-ink-600 dark:text-ink-300",
        outline: "border border-ink-200 dark:border-ink-700 bg-transparent text-ink-700 dark:text-ink-300",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
